import { useState } from "react";
import { Grid, Typography } from "@mui/material";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import { v4 as uuid } from "uuid";
import { ContentStyle, DataGridListStyle } from "../../../Theme";
import { YSButton } from "../../../uikit/YSButton";
import ConfirmPopup from "../../../components/ConfirmPopup";
import { DialogPopup } from "../../../components/DialogPopup";
import useFetch from "../../../CustomHooks/useFetch";
import NoRecords from "../../../components/NoRecords";
import ErrorOverlay from "../../../components/ErrorOverlay";
import YSSnackBar from "../../../uikit/YSSnackBar";
import AddNew from "../AddNew";
import {
  templateMedicationsList,
  templatePrescriptionRemoveDrug,
} from "../../../Apis/TemplateApis";
import { useNavigate, useParams } from "react-router-dom";

export default function PrescriptionTemplateInfoDetails(props: any) {
  const pathParams = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectionData, setSelectionData] = useState([]);
  const [deleteFavDrugPopup, setDeleteFavDrugPopup] = useState(false);
  const handleShowDeletePopupClick = () => {
    setDeleteFavDrugPopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeleteFavDrugPopup(false);
  };
  const [addFavDrugPopup, setAddFavDrugPopup] = useState(false);
  const handleShowAddFavDrugPopupClick = () => {
    setAddFavDrugPopup(true);
  };
  const handleHideAddFavDrugPopupClick = () => {
    setAddFavDrugPopup(false);
  };

  const columnsDrugs: GridColDef[] = [
    {
      field: "drugName",
      headerName: "Drug Name",
      width: 180,
      cellClassName: "w20",
      headerClassName: "w20",
    },
    {
      field: "strength",
      headerName: "Dose",
      width: 80,
      cellClassName: "w12",
      headerClassName: "w12",
    },
    {
      field: "strengthUnit",
      headerName: "Dose Unit",
      width: 110,
      cellClassName: "w15",
      headerClassName: "w15",
    },
    {
      field: "dosageForm",
      headerName: "Dose Form",
      width: 110,
      cellClassName: "w25",
      headerClassName: "w25",
    },
    {
      field: "sig",
      headerName: "SIG",
      width: 180,
      cellClassName: "w26",
      headerClassName: "w26",
    },
    {
      field: "quantity",
      headerName: "Quantity",
      width: 70,
      cellClassName: "w13",
      headerClassName: "w13",
    },
    {
      field: "refills",
      headerName: "Refills",
      width: 70,
      cellClassName: "w10",
      headerClassName: "w10",
    },
  ];

  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });

  const deleteRowData = async () => {
    try {
      const body = {
        deleteMedicationList: selectionData,
      };
      const result = await templatePrescriptionRemoveDrug(body);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        fetchApi();
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const Params = {
    templateId: pathParams?.templateId,
  };
  const { data, loading, error, fetchApi }: any = useFetch(
    Params,
    templateMedicationsList,
    []
  );

  // const [rowCountState, setRowCountState] = useState(
  //   data[0]?.pagination?.totalItems || 0
  // );
  // useEffect(() => {
  //   setRowCountState((prevRowCountState: any) =>
  //     data[0]?.pagination?.totalItems !== undefined
  //       ? data[0]?.pagination?.totalItems
  //       : prevRowCountState
  //   );
  // }, [data[0]?.pagination?.totalItems, setRowCountState]);

  return (
    <>
      <ContentStyle>
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          {" "}
          <Grid item xs={12}>
            <Typography
              className="help"
              component="h6"
              color="primary"
              variant="h6"
            >
              {data[0]?.templateName}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <DataGridListStyle>
              <DataGrid
                columns={columnsDrugs}
                rows={data[0]?.templateDrugDTOList ?? []}
                headerHeight={36}
                getRowHeight={() => "auto"}
                sortingOrder={["desc", "asc"]}
                autoHeight
                rowHeight={40}
                disableSelectionOnClick
                checkboxSelection
                getRowId={(row) => row.id ?? uuid()}
                loading={loading}
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                error={error || undefined}
                onSelectionModelChange={(ids: any) => {
                  setSelectionData(ids);
                }}
                hideFooter
                getRowClassName={(params) => {
                  if (params.row.obsoleteDrug) {
                    return "OP";
                  }
                  return "";
                }}
                // rowsPerPageOptions={[10]}
                // paginationMode="server"
                // page={page}
                // pageSize={pageSize}
                // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                // onPageChange={(newPage) => {
                //   setPage(newPage);
                // }}
                // rowCount={rowCountState}
              />
            </DataGridListStyle>
          </Grid>
          <Grid item xs={12} textAlign="center" className="btns">
            <YSButton
              onClick={() => {
                navigate("/prescription-template-info");
              }}
              className=""
              children={"Back"}
              size={"large"}
              type="button"
              color="primary"
              variant="outlined"
            />{" "}
            <YSButton
              onClick={handleShowDeletePopupClick}
              className=""
              children={"Delete"}
              size={"large"}
              type="button"
              color="primary"
              variant="outlined"
            />
            <YSButton
              onClick={handleShowAddFavDrugPopupClick}
              className=""
              children={"Add New"}
              size={"large"}
              type="button"
              color="primary"
              variant="contained"
            />{" "}
          </Grid>
        </Grid>
      </ContentStyle>
      <DialogPopup
        windowsize={"lg"}
        show={addFavDrugPopup}
        handleShowPopupClick={handleShowAddFavDrugPopupClick}
        handleHidePopupClick={handleHideAddFavDrugPopupClick}
        title="Add Medications to template"
      >
        <AddNew
          handleHideAddFavDrugPopupClick={handleHideAddFavDrugPopupClick}
          fetchApi={fetchApi}
          templateId={pathParams?.templateId}
        />
      </DialogPopup>
      <DialogPopup
        windowsize={"sm"}
        show={deleteFavDrugPopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <ConfirmPopup
          deleteRowData={deleteRowData}
          handleHideDeletePopupClick={handleHideDeletePopupClick}
        />
      </DialogPopup>
      <YSSnackBar
        message={deleteStateData.message}
        variant={deleteStateData.variant}
        open={deleteStateData.open}
        handleClose={() => {
          setDeleteStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
